export default {
  'entities.aiModel.fields.created_dt': 'Время создания',
  'entities.aiModel.fields.deleted_dt': 'Время удаления',
  'entities.aiModel.fields.id': 'Идентификатор',
  'entities.aiModel.fields.model_path': 'Путь к модели',
  'entities.aiModel.fields.name': 'Наименование',
  'entities.aiModel.fields.parent': 'Родительский элемент',
  'entities.aiModel.fields.parent_id': 'Идентификатор родителя',
  'entities.aiModel.fields.updated_dt': 'Время обновления',
  'entities.aiModel.title': 'Модель ИИ',
  'entities.application.fields.application': 'Приложение',
  'entities.application.fields.application_id': 'Идентификатор приложения',
  'entities.application.fields.created_dt': 'Время создания',
  'entities.application.fields.deleted_dt': 'Время удаления',
  'entities.application.fields.details': 'Реквизиты (JSON)',
  'entities.application.fields.id': 'Идентификатор',
  'entities.application.fields.updated_dt': 'Время обновления',
  'entities.application.title': 'Приложение',
  'entities.applicationToken.fields.access_token': 'Токен доступа',
  'entities.applicationToken.fields.access_token_expired_time': 'Истечение токена доступа',
  'entities.applicationToken.fields.created_dt': 'Время создания',
  'entities.applicationToken.fields.id': 'Идентификатор',
  'entities.applicationToken.fields.refresh_token': 'Токен обновления',
  'entities.applicationToken.fields.refresh_token_expired_time': 'Истечение токена обновления',
  'entities.applicationToken.fields.user_id': 'Идентификатор пользователя',
  'entities.applicationToken.title': 'Прикладной токен',
  'entities.authLogin.fields.email': 'Электронная почта',
  'entities.authLogin.fields.password': 'Пароль',
  'entities.authLogin.title': 'Вход',
  'entities.authRegister.fields.email': 'Электронная почта',
  'entities.authRegister.fields.name': 'Наименование',
  'entities.authRegister.fields.parent_id': 'Идентификатор родителя',
  'entities.authRegister.fields.password': 'Пароль',
  'entities.authRegister.title': 'Регистрация',
  'entities.authResponse.fields.access_token': 'Токен доступа',
  'entities.authResponse.fields.refresh_token': 'Токен обновления',
  'entities.authResponse.fields.token_type': 'Тип токена',
  'entities.authResponse.fields.user': 'Пользователь',
  'entities.authResponse.title': 'Auth Response',
  'entities.brokerEvent.fields.created_dt': 'Время создания',
  'entities.brokerEvent.fields.deleted_dt': 'Время удаления',
  'entities.brokerEvent.fields.id': 'Идентификатор',
  'entities.brokerEvent.fields.name': 'Наименование',
  'entities.brokerEvent.fields.slug': 'Обозначение (slug)',
  'entities.brokerEvent.fields.updated_dt': 'Время обновления',
  'entities.brokerEvent.title': 'Событие брокера',
  'entities.common.fields.created_dt': 'Время создания',
  'entities.common.fields.default': 'По умолчанию',
  'entities.common.fields.deleted_dt': 'Время удаления',
  'entities.common.fields.detail_scheduler_id': 'Идентификатор детали планировщика',
  'entities.common.fields.details': 'Реквизиты (JSON)',
  'entities.common.fields.email': 'Электронная почта',
  'entities.common.fields.id': 'Идентификатор',
  'entities.common.fields.login': 'Логин (email)',
  'entities.common.fields.name': 'Наименование',
  'entities.common.fields.npp': 'Порядковый номер',
  'entities.common.fields.organization_id': 'Идентификатор субъекта',
  'entities.common.fields.parent_id': 'Идентификатор родителя',
  'entities.common.fields.password': 'Пароль',
  'entities.common.fields.permission_id': 'Идентификатор разрешения',
  'entities.common.fields.pipeline_id': 'Идентификатор конвейера',
  'entities.common.fields.position_id': 'Идентификатор позиции',
  'entities.common.fields.schema_pipeline': 'Схема конвейера',
  'entities.common.fields.service_id': 'Идентификатор сервиса',
  'entities.common.fields.slug': 'Обозначение (slug)',
  'entities.common.fields.status': 'Статус',
  'entities.common.fields.status_id': 'Идентификатор статуса',
  'entities.common.fields.subject_id': 'Идентификатор субъекта',
  'entities.common.fields.token_type': 'Тип токена',
  'entities.common.fields.type': 'Тип',
  'entities.common.fields.updated_dt': 'Время обновления',
  'entities.common.fields.user': 'Пользователь',
  'entities.common.fields.user_id': 'Идентификатор пользователя',
  'entities.common.fields.version_id': 'Идентификатор версии',
  'entities.communication.fields.create_user': 'Создавший пользователь',
  'entities.communication.fields.create_user_id': 'Идентификатор создавшего пользователя',
  'entities.communication.fields.created_dt': 'Время создания',
  'entities.communication.fields.deleted_dt': 'Время удаления',
  'entities.communication.fields.id': 'Идентификатор',
  'entities.communication.fields.name': 'Наименование',
  'entities.communication.fields.slug': 'Обозначение (slug)',
  'entities.communication.fields.subject_communication': 'Субъект коммуникации (тип)',
  'entities.communication.fields.subject_communication_id': 'Идентификатор субъекта коммуникации',
  'entities.communication.fields.updated_dt': 'Время обновления',
  'entities.communication.title': 'Коммуникация',
  'entities.communicationDetail.fields.communication': 'Коммуникация',
  'entities.communicationDetail.fields.communication_id': 'Идентификатор коммуникации',
  'entities.communicationDetail.fields.created_dt': 'Время создания',
  'entities.communicationDetail.fields.deleted_dt': 'Время удаления',
  'entities.communicationDetail.fields.folder': 'Папка',
  'entities.communicationDetail.fields.folder_id': 'Идентификатор папки',
  'entities.communicationDetail.fields.id': 'Идентификатор',
  'entities.communicationDetail.fields.updated_dt': 'Время обновления',
  'entities.communicationDetail.fields.view': 'Представление',
  'entities.communicationDetail.title': 'Деталь коммуникации',
  'entities.communicationFolder.fields.created_dt': 'Время создания',
  'entities.communicationFolder.fields.deleted_dt': 'Время удаления',
  'entities.communicationFolder.fields.id': 'Идентификатор',
  'entities.communicationFolder.fields.name': 'Наименование',
  'entities.communicationFolder.fields.org_structure': 'Организационная структура',
  'entities.communicationFolder.fields.org_structure_id': 'Идентификатор оргструктуры',
  'entities.communicationFolder.fields.organization': 'Организация',
  'entities.communicationFolder.fields.organization_id': 'Идентификатор субъекта',
  'entities.communicationFolder.fields.parent': 'Родительский элемент',
  'entities.communicationFolder.fields.parent_id': 'Идентификатор родителя',
  'entities.communicationFolder.fields.slug': 'Обозначение (slug)',
  'entities.communicationFolder.fields.updated_dt': 'Время обновления',
  'entities.communicationFolder.title': 'Папка коммуникации',
  'entities.communicationHistory.fields.communication': 'Коммуникация',
  'entities.communicationHistory.fields.created_dt': 'Время создания',
  'entities.communicationHistory.fields.deleted_dt': 'Время удаления',
  'entities.communicationHistory.fields.history_running_pipelines': 'История запусков конвейера',
  'entities.communicationHistory.fields.id': 'Идентификатор',
  'entities.communicationHistory.fields.updated_dt': 'Время обновления',
  'entities.communicationHistory.fields.version': 'Версия',
  'entities.communicationHistory.fields.version_id': 'Идентификатор версии',
  'entities.communicationHistory.title': 'История коммуникации',
  'entities.communicationPermission.fields.communication': 'Коммуникация',
  'entities.communicationPermission.fields.created_dt': 'Время создания',
  'entities.communicationPermission.fields.deleted_dt': 'Время удаления',
  'entities.communicationPermission.fields.id': 'Идентификатор',
  'entities.communicationPermission.fields.org_structures': 'Организационные структуры',
  'entities.communicationPermission.fields.org_structures_id': 'Идентификатор оргструктуры (доп.)',
  'entities.communicationPermission.fields.permission': 'Разрешение / доступ',
  'entities.communicationPermission.fields.permission_id': 'Идентификатор разрешения',
  'entities.communicationPermission.fields.position': 'Позиция',
  'entities.communicationPermission.fields.position_id': 'Идентификатор позиции',
  'entities.communicationPermission.fields.updated_dt': 'Время обновления',
  'entities.communicationPermission.fields.view': 'Представление',
  'entities.communicationPermission.fields.view_id': 'Идентификатор представления',
  'entities.communicationPermission.title': 'Разрешение коммуникации',
  'entities.communicationStrategy.fields.communication': 'Коммуникация',
  'entities.communicationStrategy.fields.created_dt': 'Время создания',
  'entities.communicationStrategy.fields.deleted_dt': 'Время удаления',
  'entities.communicationStrategy.fields.id': 'Идентификатор',
  'entities.communicationStrategy.fields.provider_context_classification': 'Классификация контекста провайдера',
  'entities.communicationStrategy.fields.provider_context_classification_id': 'Идентификатор классификации',
  'entities.communicationStrategy.fields.updated_dt': 'Время обновления',
  'entities.communicationStrategy.fields.version': 'Версия',
  'entities.communicationStrategy.fields.version_id': 'Идентификатор версии',
  'entities.communicationStrategy.title': 'Стратегия коммуникации',
  'entities.communicationSubject.fields.classification_id': 'Идентификатор классификации',
  'entities.communicationSubject.fields.created_dt': 'Время создания',
  'entities.communicationSubject.fields.deleted_dt': 'Время удаления',
  'entities.communicationSubject.fields.id': 'Идентификатор',
  'entities.communicationSubject.fields.name': 'Наименование',
  'entities.communicationSubject.fields.organization': 'Организация',
  'entities.communicationSubject.fields.organization_id': 'Идентификатор субъекта',
  'entities.communicationSubject.fields.slug': 'Обозначение (slug)',
  'entities.communicationSubject.fields.type': 'Тип',
  'entities.communicationSubject.fields.type_id': 'Идентификатор типа',
  'entities.communicationSubject.fields.updated_dt': 'Время обновления',
  'entities.communicationSubject.title': 'Субъект коммуникации',
  'entities.communicationVersion.fields.communication': 'Коммуникация',
  'entities.communicationVersion.fields.create_user_id': 'Идентификатор создавшего пользователя',
  'entities.communicationVersion.fields.created_dt': 'Время создания',
  'entities.communicationVersion.fields.default': 'По умолчанию',
  'entities.communicationVersion.fields.deleted_dt': 'Время удаления',
  'entities.communicationVersion.fields.id': 'Идентификатор',
  'entities.communicationVersion.fields.name': 'Наименование',
  'entities.communicationVersion.fields.npp': 'Порядковый номер',
  'entities.communicationVersion.fields.pipeline': 'Конвейер',
  'entities.communicationVersion.fields.pipeline_id': 'Идентификатор конвейера',
  'entities.communicationVersion.fields.updated_dt': 'Время обновления',
  'entities.communicationVersion.title': 'Версия коммуникации',
  'entities.communicationView.fields.created_dt': 'Время создания',
  'entities.communicationView.fields.deleted_dt': 'Время удаления',
  'entities.communicationView.fields.id': 'Идентификатор',
  'entities.communicationView.fields.name': 'Наименование',
  'entities.communicationView.fields.organization': 'Организация',
  'entities.communicationView.fields.organization_id': 'Идентификатор субъекта',
  'entities.communicationView.fields.slug': 'Обозначение (slug)',
  'entities.communicationView.fields.updated_dt': 'Время обновления',
  'entities.communicationView.title': 'Представление коммуникации',
  'entities.contextClassifier.fields.created_dt': 'Время создания',
  'entities.contextClassifier.fields.deleted_dt': 'Время удаления',
  'entities.contextClassifier.fields.id': 'Идентификатор',
  'entities.contextClassifier.fields.name': 'Наименование',
  'entities.contextClassifier.fields.organization': 'Организация',
  'entities.contextClassifier.fields.organization_id': 'Идентификатор субъекта',
  'entities.contextClassifier.fields.slug': 'Обозначение (slug)',
  'entities.contextClassifier.fields.updated_dt': 'Время обновления',
  'entities.contextClassifier.title': 'Классификатор контекста',
  'entities.contextData.fields.created_dt': 'Время создания',
  'entities.contextData.fields.data_key': 'Ключ данных / схема',
  'entities.contextData.fields.deleted_dt': 'Время удаления',
  'entities.contextData.fields.id': 'Идентификатор',
  'entities.contextData.fields.name': 'Наименование',
  'entities.contextData.fields.source': 'Источник',
  'entities.contextData.fields.storage': 'Хранилище',
  'entities.contextData.fields.storage_id': 'Идентификатор хранилища',
  'entities.contextData.fields.updated_dt': 'Время обновления',
  'entities.contextData.fields.version': 'Версия',
  'entities.contextData.fields.version_id': 'Идентификатор версии',
  'entities.contextData.title': 'Элемент данных контекста',
  'entities.contextPipeline.fields.created_dt': 'Время создания',
  'entities.contextPipeline.fields.data': 'Данные',
  'entities.contextPipeline.fields.data_id': 'Идентификатор данных',
  'entities.contextPipeline.fields.deleted_dt': 'Время удаления',
  'entities.contextPipeline.fields.id': 'Идентификатор',
  'entities.contextPipeline.fields.name': 'Наименование',
  'entities.contextPipeline.fields.pipeline': 'Конвейер',
  'entities.contextPipeline.fields.pipeline_id': 'Идентификатор конвейера',
  'entities.contextPipeline.fields.provider': 'Провайдер',
  'entities.contextPipeline.fields.storage': 'Хранилище',
  'entities.contextPipeline.fields.storage_id': 'Идентификатор хранилища',
  'entities.contextPipeline.fields.updated_dt': 'Время обновления',
  'entities.contextPipeline.title': 'Конвейер контекста',
  'entities.contextStorage.fields.created_dt': 'Время создания',
  'entities.contextStorage.fields.deleted_dt': 'Время удаления',
  'entities.contextStorage.fields.id': 'Идентификатор',
  'entities.contextStorage.fields.name': 'Наименование',
  'entities.contextStorage.fields.organization': 'Организация',
  'entities.contextStorage.fields.organization_id': 'Идентификатор субъекта',
  'entities.contextStorage.fields.provider': 'Провайдер',
  'entities.contextStorage.fields.updated_dt': 'Время обновления',
  'entities.contextStorage.fields.version': 'Версия',
  'entities.contextStorage.fields.version_id': 'Идентификатор версии',
  'entities.contextStorage.title': 'Хранилище контекста',
  'entities.dataPipeline.fields.created_dt': 'Время создания',
  'entities.dataPipeline.fields.deleted_dt': 'Время удаления',
  'entities.dataPipeline.fields.id': 'Идентификатор',
  'entities.dataPipeline.fields.name': 'Наименование',
  'entities.dataPipeline.fields.organization': 'Организация',
  'entities.dataPipeline.fields.organization_id': 'Идентификатор субъекта',
  'entities.dataPipeline.fields.type_param_service_id': 'Идентификатор параметров сервиса',
  'entities.dataPipeline.fields.updated_dt': 'Время обновления',
  'entities.dataPipeline.title': 'Конвейер данных',
  'entities.dataPipelineDetail.fields.created_dt': 'Время создания',
  'entities.dataPipelineDetail.fields.deleted_dt': 'Время удаления',
  'entities.dataPipelineDetail.fields.environment': 'Окружение',
  'entities.dataPipelineDetail.fields.id': 'Идентификатор',
  'entities.dataPipelineDetail.fields.input_params': 'Входные параметры',
  'entities.dataPipelineDetail.fields.output_params': 'Выходные параметры',
  'entities.dataPipelineDetail.fields.test_pipeline': 'Тестовый конвейер',
  'entities.dataPipelineDetail.fields.updated_dt': 'Время обновления',
  'entities.dataPipelineDetail.title': 'Детализация конвейера данных',
  'entities.dependentVersionService.fields.created_dt': 'Время создания',
  'entities.dependentVersionService.fields.deleted_dt': 'Время удаления',
  'entities.dependentVersionService.fields.dependent': 'Зависимость',
  'entities.dependentVersionService.fields.id': 'Идентификатор',
  'entities.dependentVersionService.fields.updated_dt': 'Время обновления',
  'entities.dependentVersionService.fields.version': 'Версия',
  'entities.dependentVersionService.title': 'Зависимость версии сервиса',
  'entities.detailScheduler.fields.created_dt': 'Время создания',
  'entities.detailScheduler.fields.deleted_dt': 'Время удаления',
  'entities.detailScheduler.fields.id': 'Идентификатор',
  'entities.detailScheduler.fields.run_dt': 'Время запуска',
  'entities.detailScheduler.fields.scheduler': 'Планировщик',
  'entities.detailScheduler.fields.updated_dt': 'Время обновления',
  'entities.detailScheduler.title': 'Элемент выполнения планировщика',
  'entities.division.fields.created_dt': 'Время создания',
  'entities.division.fields.deleted_dt': 'Время удаления',
  'entities.division.fields.details': 'Реквизиты (JSON)',
  'entities.division.fields.division': 'Подразделение',
  'entities.division.fields.division_id': 'Идентификатор подразделения',
  'entities.division.fields.id': 'Идентификатор',
  'entities.division.fields.updated_dt': 'Время обновления',
  'entities.division.title': 'Подразделение',
  'entities.groupContextClassifier.fields.classifier': 'Классификатор',
  'entities.groupContextClassifier.fields.classifier_id': 'Идентификатор классификатора',
  'entities.groupContextClassifier.fields.created_dt': 'Время создания',
  'entities.groupContextClassifier.fields.deleted_dt': 'Время удаления',
  'entities.groupContextClassifier.fields.id': 'Идентификатор',
  'entities.groupContextClassifier.fields.parent_classifier': 'Родительский классификатор',
  'entities.groupContextClassifier.fields.parent_classifier_id': 'Идентификатор родительского классификатора',
  'entities.groupContextClassifier.fields.updated_dt': 'Время обновления',
  'entities.groupContextClassifier.title': 'Группа классификаторов контекста',
  'entities.historyRunningPipeline.fields.created_dt': 'Время создания',
  'entities.historyRunningPipeline.fields.deleted_dt': 'Время удаления',
  'entities.historyRunningPipeline.fields.environment': 'Окружение',
  'entities.historyRunningPipeline.fields.exit_dt': 'Время завершения',
  'entities.historyRunningPipeline.fields.id': 'Идентификатор',
  'entities.historyRunningPipeline.fields.input_params': 'Входные параметры',
  'entities.historyRunningPipeline.fields.output_params': 'Выходные параметры',
  'entities.historyRunningPipeline.fields.pipeline': 'Конвейер',
  'entities.historyRunningPipeline.fields.run_dt': 'Время запуска',
  'entities.historyRunningPipeline.fields.schema': 'Схема конвейера',
  'entities.historyRunningPipeline.fields.schema_id': 'Идентификатор схемы',
  'entities.historyRunningPipeline.fields.updated_dt': 'Время обновления',
  'entities.historyRunningPipeline.fields.user_id': 'Идентификатор пользователя',
  'entities.historyRunningPipeline.title': 'История запуска конвейера',
  'entities.historyRunningStreamPipeline.fields.created_dt': 'Время создания',
  'entities.historyRunningStreamPipeline.fields.deleted_dt': 'Время удаления',
  'entities.historyRunningStreamPipeline.fields.exit_dt': 'Время завершения',
  'entities.historyRunningStreamPipeline.fields.id': 'Идентификатор',
  'entities.historyRunningStreamPipeline.fields.run_dt': 'Время запуска',
  'entities.historyRunningStreamPipeline.fields.schema': 'Схема конвейера',
  'entities.historyRunningStreamPipeline.fields.schema_id': 'Идентификатор схемы',
  'entities.historyRunningStreamPipeline.fields.stream_params': 'Параметры потока',
  'entities.historyRunningStreamPipeline.fields.updated_dt': 'Время обновления',
  'entities.historyRunningStreamPipeline.title': 'История потокового конвейера',
  'entities.individual.fields.created_dt': 'Время создания',
  'entities.individual.fields.deleted_dt': 'Время удаления',
  'entities.individual.fields.details': 'Реквизиты (JSON)',
  'entities.individual.fields.id': 'Идентификатор',
  'entities.individual.fields.subject': 'Субъект',
  'entities.individual.fields.subject_id': 'Идентификатор субъекта',
  'entities.individual.fields.updated_dt': 'Время обновления',
  'entities.individual.title': 'Физическое лицо',
  'entities.jwtToken.fields.access_token': 'Токен доступа',
  'entities.jwtToken.fields.access_token_expired_time': 'Истечение токена доступа',
  'entities.jwtToken.fields.created_dt': 'Время создания',
  'entities.jwtToken.fields.deleted_dt': 'Время удаления',
  'entities.jwtToken.fields.id': 'Идентификатор',
  'entities.jwtToken.fields.refresh_token': 'Токен обновления',
  'entities.jwtToken.fields.refresh_token_expired_time': 'Истечение токена обновления',
  'entities.jwtToken.fields.updated_dt': 'Время обновления',
  'entities.jwtToken.fields.user_id': 'Идентификатор пользователя',
  'entities.jwtToken.title': 'Запись JWT токена',
  'entities.organization.fields.created_dt': 'Время создания',
  'entities.organization.fields.deleted_dt': 'Время удаления',
  'entities.organization.fields.details': 'Реквизиты (JSON)',
  'entities.organization.fields.id': 'Идентификатор',
  'entities.organization.fields.name': 'Наименование',
  'entities.organization.fields.organization': 'Организация',
  'entities.organization.fields.updated_dt': 'Время обновления',
  'entities.organization.title': 'Организация',
  'entities.organizationPosition.fields.created_dt': 'Время создания',
  'entities.organizationPosition.fields.deleted_dt': 'Время удаления',
  'entities.organizationPosition.fields.id': 'Идентификатор',
  'entities.organizationPosition.fields.name': 'Наименование',
  'entities.organizationPosition.fields.organization': 'Организация',
  'entities.organizationPosition.fields.organization_id': 'Идентификатор субъекта',
  'entities.organizationPosition.fields.slug': 'Обозначение (slug)',
  'entities.organizationPosition.fields.updated_dt': 'Время обновления',
  'entities.organizationPosition.title': 'Позиция организации',
  'entities.organizationStructure.fields.created_dt': 'Время создания',
  'entities.organizationStructure.fields.deleted_dt': 'Время удаления',
  'entities.organizationStructure.fields.id': 'Идентификатор',
  'entities.organizationStructure.fields.name': 'Наименование',
  'entities.organizationStructure.fields.organization': 'Организация',
  'entities.organizationStructure.fields.organization_id': 'Идентификатор субъекта',
  'entities.organizationStructure.fields.parent': 'Родительский элемент',
  'entities.organizationStructure.fields.parent_id': 'Идентификатор родителя',
  'entities.organizationStructure.fields.position': 'Позиция',
  'entities.organizationStructure.fields.position_id': 'Идентификатор позиции',
  'entities.organizationStructure.fields.status': 'Статус',
  'entities.organizationStructure.fields.subject': 'Субъект',
  'entities.organizationStructure.fields.subject_id': 'Идентификатор субъекта',
  'entities.organizationStructure.fields.type': 'Тип',
  'entities.organizationStructure.fields.updated_dt': 'Время обновления',
  'entities.organizationStructure.title': 'Организационная структура',
  'entities.organizationStructureInvite.fields.invite_id': 'Идентификатор приглашения',
  'entities.organizationStructureInvite.fields.name': 'Наименование',
  'entities.organizationStructureInvite.fields.organization_id': 'Идентификатор субъекта',
  'entities.organizationStructureInvite.fields.position_id': 'Идентификатор позиции',
  'entities.organizationStructureInvite.fields.subject_id': 'Идентификатор субъекта',
  'entities.organizationStructureInvite.title': 'Приглашение в оргструктуру',
  'entities.organizationStructurePermission.fields.created_dt': 'Время создания',
  'entities.organizationStructurePermission.fields.deleted_dt': 'Время удаления',
  'entities.organizationStructurePermission.fields.id': 'Идентификатор',
  'entities.organizationStructurePermission.fields.org_structure': 'Организационная структура',
  'entities.organizationStructurePermission.fields.org_structure_id': 'Идентификатор оргструктуры',
  'entities.organizationStructurePermission.fields.organization': 'Организация',
  'entities.organizationStructurePermission.fields.organization_id': 'Идентификатор субъекта',
  'entities.organizationStructurePermission.fields.permission': 'Разрешение / доступ',
  'entities.organizationStructurePermission.fields.permission_id': 'Идентификатор разрешения',
  'entities.organizationStructurePermission.fields.subject_org_structure_id': 'Оргструктура субъекта доступа',
  'entities.organizationStructurePermission.fields.updated_dt': 'Время обновления',
  'entities.organizationStructurePermission.title': 'Доступ к оргструктуре',
  'entities.permission.fields.created_dt': 'Время создания',
  'entities.permission.fields.id': 'Идентификатор',
  'entities.permission.fields.name': 'Наименование',
  'entities.permission.fields.slug': 'Обозначение (slug)',
  'entities.permission.fields.updated_dt': 'Время обновления',
  'entities.permission.title': 'Разрешение (доступ)',
  'entities.pipeline.fields.broker_event': 'Событие брокера',
  'entities.pipeline.fields.broker_event_id': 'Идентификатор события брокера',
  'entities.pipeline.fields.build_dt': 'Время сборки',
  'entities.pipeline.fields.build_id': 'Идентификатор сборки',
  'entities.pipeline.fields.created_dt': 'Время создания',
  'entities.pipeline.fields.deleted_dt': 'Время удаления',
  'entities.pipeline.fields.id': 'Идентификатор',
  'entities.pipeline.fields.name': 'Наименование',
  'entities.pipeline.fields.organization': 'Организация',
  'entities.pipeline.fields.organization_id': 'Идентификатор субъекта',
  'entities.pipeline.fields.run_dt': 'Время запуска',
  'entities.pipeline.fields.run_id': 'Идентификатор запуска',
  'entities.pipeline.fields.status': 'Статус',
  'entities.pipeline.fields.updated_dt': 'Время обновления',
  'entities.pipeline.title': 'Конвейер',
  'entities.providerContext.fields.created_dt': 'Время создания',
  'entities.providerContext.fields.data': 'Данные',
  'entities.providerContext.fields.deleted_dt': 'Время удаления',
  'entities.providerContext.fields.id': 'Идентификатор',
  'entities.providerContext.fields.limit': 'Лимит',
  'entities.providerContext.fields.name': 'Наименование',
  'entities.providerContext.fields.organization': 'Организация',
  'entities.providerContext.fields.organization_id': 'Идентификатор субъекта',
  'entities.providerContext.fields.service': 'Сервис',
  'entities.providerContext.fields.service_id': 'Идентификатор сервиса',
  'entities.providerContext.fields.slug': 'Обозначение (slug)',
  'entities.providerContext.fields.type_provider': 'Тип провайдера',
  'entities.providerContext.fields.updated_dt': 'Время обновления',
  'entities.providerContext.title': 'Контекст провайдера',
  'entities.providerContextClassifier.fields.classifier': 'Классификатор',
  'entities.providerContextClassifier.fields.classifier_id': 'Идентификатор классификатора',
  'entities.providerContextClassifier.fields.created_dt': 'Время создания',
  'entities.providerContextClassifier.fields.deleted_dt': 'Время удаления',
  'entities.providerContextClassifier.fields.id': 'Идентификатор',
  'entities.providerContextClassifier.fields.name': 'Наименование',
  'entities.providerContextClassifier.fields.provider': 'Провайдер',
  'entities.providerContextClassifier.fields.provider_id': 'Идентификатор провайдера',
  'entities.providerContextClassifier.fields.storage': 'Хранилище',
  'entities.providerContextClassifier.fields.updated_dt': 'Время обновления',
  'entities.providerContextClassifier.title': 'Классификатор контекста провайдера',
  'entities.resultContextClassifier.fields.context_pipeline': 'Конвейер контекста',
  'entities.resultContextClassifier.fields.created_dt': 'Время создания',
  'entities.resultContextClassifier.fields.data_pipeline': 'Конвейер данных',
  'entities.resultContextClassifier.fields.deleted_dt': 'Время удаления',
  'entities.resultContextClassifier.fields.id': 'Идентификатор',
  'entities.resultContextClassifier.fields.storage_data': 'Данные хранилища',
  'entities.resultContextClassifier.fields.updated_dt': 'Время обновления',
  'entities.resultContextClassifier.title': 'Итоговый классификатор контекста',
  'entities.resultScheduler.fields.created_dt': 'Время создания',
  'entities.resultScheduler.fields.deleted_dt': 'Время удаления',
  'entities.resultScheduler.fields.detail_scheduler': 'Элемент выполнения планировщика',
  'entities.resultScheduler.fields.history_running_pipeline': 'Запись запуска конвейера',
  'entities.resultScheduler.fields.history_running_pipeline_id': 'Идентификатор истории запуска',
  'entities.resultScheduler.fields.id': 'Идентификатор',
  'entities.resultScheduler.fields.updated_dt': 'Время обновления',
  'entities.resultScheduler.title': 'Результат планировщика',
  'entities.role.fields.created_dt': 'Время создания',
  'entities.role.fields.id': 'Идентификатор',
  'entities.role.fields.name': 'Наименование',
  'entities.role.fields.slug': 'Обозначение (slug)',
  'entities.role.fields.updated_dt': 'Время обновления',
  'entities.role.title': 'Роль',
  'entities.running.fields.created_dt': 'Время создания',
  'entities.running.fields.deleted_dt': 'Время удаления',
  'entities.running.fields.id': 'Идентификатор',
  'entities.running.fields.name': 'Наименование',
  'entities.running.fields.slug': 'Обозначение (slug)',
  'entities.running.fields.updated_dt': 'Время обновления',
  'entities.running.title': 'Тип выполнения',
  'entities.scheduler.fields.created_dt': 'Время создания',
  'entities.scheduler.fields.data_pipeline': 'Конвейер данных',
  'entities.scheduler.fields.data_pipeline_id': 'Идентификатор конвейера данных',
  'entities.scheduler.fields.deleted_dt': 'Время удаления',
  'entities.scheduler.fields.id': 'Идентификатор',
  'entities.scheduler.fields.name': 'Наименование',
  'entities.scheduler.fields.pipeline': 'Конвейер',
  'entities.scheduler.fields.pipeline_id': 'Идентификатор конвейера',
  'entities.scheduler.fields.updated_dt': 'Время обновления',
  'entities.scheduler.title': 'Планировщик',
  'entities.schemaPipeline.fields.broker_event': 'Событие брокера',
  'entities.schemaPipeline.fields.broker_event_id': 'Идентификатор события брокера',
  'entities.schemaPipeline.fields.created_dt': 'Время создания',
  'entities.schemaPipeline.fields.deleted_dt': 'Время удаления',
  'entities.schemaPipeline.fields.id': 'Идентификатор',
  'entities.schemaPipeline.fields.name': 'Наименование',
  'entities.schemaPipeline.fields.pipeline': 'Конвейер',
  'entities.schemaPipeline.fields.service': 'Сервис',
  'entities.schemaPipeline.fields.service_id': 'Идентификатор сервиса',
  'entities.schemaPipeline.fields.type_event': 'Тип события',
  'entities.schemaPipeline.fields.type_event_id': 'Идентификатор типа события',
  'entities.schemaPipeline.fields.type_exit_event_id': 'Тип события выхода',
  'entities.schemaPipeline.fields.type_running': 'Тип выполнения',
  'entities.schemaPipeline.fields.type_running_id': 'Идентификатор типа выполнения',
  'entities.schemaPipeline.fields.type_stream_event_id': 'Тип события потока',
  'entities.schemaPipeline.fields.updated_dt': 'Время обновления',
  'entities.schemaPipeline.fields.version': 'Версия',
  'entities.schemaPipeline.fields.version_id': 'Идентификатор версии',
  'entities.schemaPipeline.title': 'Схема конвейера',
  'entities.service.fields.created_dt': 'Время создания',
  'entities.service.fields.deleted_dt': 'Время удаления',
  'entities.service.fields.id': 'Идентификатор',
  'entities.service.fields.name': 'Наименование',
  'entities.service.fields.organization': 'Организация',
  'entities.service.fields.organization_id': 'Идентификатор субъекта',
  'entities.service.fields.slug': 'Обозначение (slug)',
  'entities.service.fields.type_service': 'Тип сервиса',
  'entities.service.fields.type_service_id': 'Идентификатор типа сервиса',
  'entities.service.fields.updated_dt': 'Время обновления',
  'entities.service.title': 'Сервис',
  'entities.serviceBuild.fields.build_dt': 'Время сборки',
  'entities.serviceBuild.fields.build_id': 'Идентификатор сборки',
  'entities.serviceBuild.fields.service_id': 'Идентификатор сервиса',
  'entities.serviceBuild.fields.status': 'Статус',
  'entities.serviceBuild.fields.version_id': 'Идентификатор версии',
  'entities.serviceBuild.title': 'Service Build',
  'entities.serviceEvent.fields.created_dt': 'Время создания',
  'entities.serviceEvent.fields.deleted_dt': 'Время удаления',
  'entities.serviceEvent.fields.id': 'Идентификатор',
  'entities.serviceEvent.fields.name': 'Наименование',
  'entities.serviceEvent.fields.organization': 'Организация',
  'entities.serviceEvent.fields.organization_id': 'Идентификатор субъекта',
  'entities.serviceEvent.fields.slug': 'Обозначение (slug)',
  'entities.serviceEvent.fields.type_service': 'Тип сервиса',
  'entities.serviceEvent.fields.type_service_id': 'Идентификатор типа сервиса',
  'entities.serviceEvent.fields.updated_dt': 'Время обновления',
  'entities.serviceEvent.title': 'Событие сервиса',
  'entities.serviceParams.fields.created_dt': 'Время создания',
  'entities.serviceParams.fields.deleted_dt': 'Время удаления',
  'entities.serviceParams.fields.details': 'Реквизиты (JSON)',
  'entities.serviceParams.fields.details_id': 'Идентификатор шаблона параметров',
  'entities.serviceParams.fields.id': 'Идентификатор',
  'entities.serviceParams.fields.name': 'Наименование',
  'entities.serviceParams.fields.organization': 'Организация',
  'entities.serviceParams.fields.organization_id': 'Идентификатор субъекта',
  'entities.serviceParams.fields.slug': 'Обозначение (slug)',
  'entities.serviceParams.fields.type_service': 'Тип сервиса',
  'entities.serviceParams.fields.type_service_id': 'Идентификатор типа сервиса',
  'entities.serviceParams.fields.updated_dt': 'Время обновления',
  'entities.serviceParams.title': 'Параметры сервиса',
  'entities.serviceRun.fields.run_dt': 'Время запуска',
  'entities.serviceRun.fields.run_id': 'Идентификатор запуска',
  'entities.serviceRun.fields.service_id': 'Идентификатор сервиса',
  'entities.serviceRun.fields.status_id': 'Идентификатор статуса',
  'entities.serviceRun.title': 'Service Run',
  'entities.serviceType.fields.created_dt': 'Время создания',
  'entities.serviceType.fields.deleted_dt': 'Время удаления',
  'entities.serviceType.fields.id': 'Идентификатор',
  'entities.serviceType.fields.name': 'Наименование',
  'entities.serviceType.fields.slug': 'Обозначение (slug)',
  'entities.serviceType.fields.updated_dt': 'Время обновления',
  'entities.serviceType.title': 'Тип сервиса',
  'entities.serviceVersion.fields.cache': 'Кэширование',
  'entities.serviceVersion.fields.code': 'Код',
  'entities.serviceVersion.fields.created_dt': 'Время создания',
  'entities.serviceVersion.fields.default': 'По умолчанию',
  'entities.serviceVersion.fields.deleted_dt': 'Время удаления',
  'entities.serviceVersion.fields.id': 'Идентификатор',
  'entities.serviceVersion.fields.input_type_params': 'Тип входных параметров',
  'entities.serviceVersion.fields.name': 'Наименование',
  'entities.serviceVersion.fields.npp': 'Порядковый номер',
  'entities.serviceVersion.fields.output_type_params': 'Тип выходных параметров',
  'entities.serviceVersion.fields.service': 'Сервис',
  'entities.serviceVersion.fields.stream_type_params': 'Тип параметров потока',
  'entities.serviceVersion.fields.updated_dt': 'Время обновления',
  'entities.serviceVersion.title': 'Версия сервиса',
  'entities.serviceVersionBuild.fields.build_dt': 'Время сборки',
  'entities.serviceVersionBuild.fields.build_id': 'Идентификатор сборки',
  'entities.serviceVersionBuild.fields.service_id': 'Идентификатор сервиса',
  'entities.serviceVersionBuild.fields.status': 'Статус',
  'entities.serviceVersionBuild.title': 'Service Version Build',
  'entities.serviceVersionRun.fields.run_dt': 'Время запуска',
  'entities.serviceVersionRun.fields.run_id': 'Идентификатор запуска',
  'entities.serviceVersionRun.fields.service_id': 'Идентификатор сервиса',
  'entities.serviceVersionRun.fields.status': 'Статус',
  'entities.serviceVersionRun.title': 'Service Version Run',
  'entities.shareContextStorage.fields.created_dt': 'Время создания',
  'entities.shareContextStorage.fields.deleted_dt': 'Время удаления',
  'entities.shareContextStorage.fields.id': 'Идентификатор',
  'entities.shareContextStorage.fields.organization': 'Организация',
  'entities.shareContextStorage.fields.organization_id': 'Идентификатор субъекта',
  'entities.shareContextStorage.fields.provider': 'Провайдер',
  'entities.shareContextStorage.fields.storage': 'Хранилище',
  'entities.shareContextStorage.fields.storage_id': 'Идентификатор хранилища',
  'entities.shareContextStorage.fields.updated_dt': 'Время обновления',
  'entities.shareContextStorage.title': 'Общее хранилище контекста',
  'entities.subject.fields.create_user_id': 'Идентификатор создавшего пользователя',
  'entities.subject.fields.created_dt': 'Время создания',
  'entities.subject.fields.deleted_dt': 'Время удаления',
  'entities.subject.fields.id': 'Идентификатор',
  'entities.subject.fields.name': 'Наименование',
  'entities.subject.fields.parent_id': 'Идентификатор родителя',
  'entities.subject.fields.type': 'Тип',
  'entities.subject.fields.updated_dt': 'Время обновления',
  'entities.subject.title': 'Субъект',
  'entities.subjectType.fields.created_dt': 'Время создания',
  'entities.subjectType.fields.name': 'Наименование',
  'entities.subjectType.fields.slug': 'Обозначение (slug)',
  'entities.subjectType.fields.subjectTypeId': 'Идентификатор типа субъекта',
  'entities.subjectType.fields.updated_dt': 'Время обновления',
  'entities.subjectType.title': 'Тип субъекта',
  'entities.testPipeline.fields.created_dt': 'Время создания',
  'entities.testPipeline.fields.data_pipeline': 'Конвейер данных',
  'entities.testPipeline.fields.data_pipeline_id': 'Идентификатор конвейера данных',
  'entities.testPipeline.fields.deleted_dt': 'Время удаления',
  'entities.testPipeline.fields.distance_service': 'Сервис расстояния',
  'entities.testPipeline.fields.distance_service_id': 'Идентификатор сервиса расстояния',
  'entities.testPipeline.fields.distance_version_service': 'Версия сервиса расстояния',
  'entities.testPipeline.fields.distance_version_service_id': 'Идентификатор версии сервиса расстояния',
  'entities.testPipeline.fields.exit_dt': 'Время завершения',
  'entities.testPipeline.fields.id': 'Идентификатор',
  'entities.testPipeline.fields.is_stopped': 'Остановлен',
  'entities.testPipeline.fields.name': 'Наименование',
  'entities.testPipeline.fields.run_dt': 'Время запуска',
  'entities.testPipeline.fields.status': 'Статус',
  'entities.testPipeline.fields.updated_dt': 'Время обновления',
  'entities.testPipeline.title': 'Тестовый конвейер',
  'entities.testResultPipeline.fields.created_dt': 'Время создания',
  'entities.testResultPipeline.fields.data_detail_pipeline': 'Детали конвейера данных',
  'entities.testResultPipeline.fields.data_detail_pipeline_id': 'Идентификатор детализации данных',
  'entities.testResultPipeline.fields.deleted_dt': 'Время удаления',
  'entities.testResultPipeline.fields.distance': 'Метрика расстояния',
  'entities.testResultPipeline.fields.history_running_pipeline': 'Запись запуска конвейера',
  'entities.testResultPipeline.fields.history_running_pipeline_id': 'Идентификатор истории запуска',
  'entities.testResultPipeline.fields.id': 'Идентификатор',
  'entities.testResultPipeline.fields.test': 'Тест',
  'entities.testResultPipeline.fields.updated_dt': 'Время обновления',
  'entities.testResultPipeline.title': 'Результат тестового конвейера',
  'entities.tuneModel.fields.created_dt': 'Время создания',
  'entities.tuneModel.fields.data_pipeline': 'Конвейер данных',
  'entities.tuneModel.fields.data_pipeline_id': 'Идентификатор конвейера данных',
  'entities.tuneModel.fields.deleted_dt': 'Время удаления',
  'entities.tuneModel.fields.distance_service': 'Сервис расстояния',
  'entities.tuneModel.fields.distance_service_id': 'Идентификатор сервиса расстояния',
  'entities.tuneModel.fields.distance_version_service': 'Версия сервиса расстояния',
  'entities.tuneModel.fields.distance_version_service_id': 'Идентификатор версии сервиса расстояния',
  'entities.tuneModel.fields.exit_dt': 'Время завершения',
  'entities.tuneModel.fields.id': 'Идентификатор',
  'entities.tuneModel.fields.model': 'Модель',
  'entities.tuneModel.fields.model_id': 'Идентификатор модели',
  'entities.tuneModel.fields.name': 'Наименование',
  'entities.tuneModel.fields.run_dt': 'Время запуска',
  'entities.tuneModel.fields.status': 'Статус',
  'entities.tuneModel.fields.stopped': 'Остановлено',
  'entities.tuneModel.fields.updated_dt': 'Время обновления',
  'entities.tuneModel.title': 'Задача дообучения',
  'entities.tuneModelResult.fields.created_dt': 'Время создания',
  'entities.tuneModelResult.fields.deleted_dt': 'Время удаления',
  'entities.tuneModelResult.fields.history_running_pipeline': 'Запись запуска конвейера',
  'entities.tuneModelResult.fields.history_running_pipeline_id': 'Идентификатор истории запуска',
  'entities.tuneModelResult.fields.id': 'Идентификатор',
  'entities.tuneModelResult.fields.model': 'Модель',
  'entities.tuneModelResult.fields.model_id': 'Идентификатор модели',
  'entities.tuneModelResult.fields.tuning': 'Задача дообучения',
  'entities.tuneModelResult.fields.updated_dt': 'Время обновления',
  'entities.tuneModelResult.title': 'Результат дообучения модели',
  'entities.typeProviderContext.fields.created_dt': 'Время создания',
  'entities.typeProviderContext.fields.deleted_dt': 'Время удаления',
  'entities.typeProviderContext.fields.id': 'Идентификатор',
  'entities.typeProviderContext.fields.name': 'Наименование',
  'entities.typeProviderContext.fields.organization': 'Организация',
  'entities.typeProviderContext.fields.organization_id': 'Идентификатор субъекта',
  'entities.typeProviderContext.fields.slug': 'Обозначение (slug)',
  'entities.typeProviderContext.fields.updated_dt': 'Время обновления',
  'entities.typeProviderContext.title': 'Тип контекста провайдера',
  'entities.typeSubjectCommunication.fields.created_dt': 'Время создания',
  'entities.typeSubjectCommunication.fields.deleted_dt': 'Время удаления',
  'entities.typeSubjectCommunication.fields.id': 'Идентификатор',
  'entities.typeSubjectCommunication.fields.name': 'Наименование',
  'entities.typeSubjectCommunication.fields.organization': 'Организация',
  'entities.typeSubjectCommunication.fields.organization_id': 'Идентификатор субъекта',
  'entities.typeSubjectCommunication.fields.slug': 'Обозначение (slug)',
  'entities.typeSubjectCommunication.fields.updated_dt': 'Время обновления',
  'entities.typeSubjectCommunication.title': 'Тип субъекта коммуникации',
  'entities.user.fields.created_dt': 'Время создания',
  'entities.user.fields.deleted_dt': 'Время удаления',
  'entities.user.fields.email': 'Электронная почта',
  'entities.user.fields.id': 'Идентификатор',
  'entities.user.fields.is_active': 'Активен',
  'entities.user.fields.login': 'Логин (email)',
  'entities.user.fields.name': 'Наименование',
  'entities.user.fields.parent_id': 'Идентификатор родителя',
  'entities.user.fields.password': 'Пароль',
  'entities.user.fields.role': 'Роль',
  'entities.user.fields.updated_dt': 'Время обновления',
  'entities.user.fields.user_id': 'Идентификатор пользователя',
  'entities.user.title': 'Пользователь',
  'entities.userContext.fields.current_user_id': 'Текущий пользователь',
  'entities.userContext.fields.org_structure_id': 'Идентификатор оргструктуры',
  'entities.userContext.fields.org_structure_name': 'Название оргструктуры',
  'entities.userContext.fields.organization_id': 'Идентификатор субъекта',
  'entities.userContext.fields.organization_name': 'Название организации',
  'entities.userContext.fields.parent_user_id': 'Родительский пользователь',
  'entities.userContext.title': 'Контекст пользователя',
  'entities.userOrganizationStructure.fields.access_token': 'Токен доступа',
  'entities.userOrganizationStructure.fields.access_token_expired_time': 'Истечение токена доступа',
  'entities.userOrganizationStructure.fields.created_dt': 'Время создания',
  'entities.userOrganizationStructure.fields.deleted_dt': 'Время удаления',
  'entities.userOrganizationStructure.fields.id': 'Идентификатор',
  'entities.userOrganizationStructure.fields.org_structure': 'Организационная структура',
  'entities.userOrganizationStructure.fields.org_structure_id': 'Идентификатор оргструктуры',
  'entities.userOrganizationStructure.fields.organization': 'Организация',
  'entities.userOrganizationStructure.fields.organization_id': 'Идентификатор субъекта',
  'entities.userOrganizationStructure.fields.refresh_token': 'Токен обновления',
  'entities.userOrganizationStructure.fields.refresh_token_expired_time': 'Истечение токена обновления',
  'entities.userOrganizationStructure.fields.updated_dt': 'Время обновления',
  'entities.userOrganizationStructure.fields.user_id': 'Идентификатор пользователя',
  'entities.userOrganizationStructure.title': 'Пользователь в оргструктуре',
  'entities.versionProviderContext.fields.created_dt': 'Время создания',
  'entities.versionProviderContext.fields.data': 'Данные',
  'entities.versionProviderContext.fields.default': 'По умолчанию',
  'entities.versionProviderContext.fields.deleted_dt': 'Время удаления',
  'entities.versionProviderContext.fields.id': 'Идентификатор',
  'entities.versionProviderContext.fields.limit': 'Лимит',
  'entities.versionProviderContext.fields.name': 'Наименование',
  'entities.versionProviderContext.fields.npp': 'Порядковый номер',
  'entities.versionProviderContext.fields.provider': 'Провайдер',
  'entities.versionProviderContext.fields.updated_dt': 'Время обновления',
  'entities.versionProviderContext.fields.version': 'Версия',
  'entities.versionProviderContext.fields.version_id': 'Идентификатор версии',
  'entities.versionProviderContext.title': 'Версия контекста провайдера',
};
